import { useIntl, defineMessages } from 'react-intl'
import Section from '../Section/Section'
import { ListingCardNew } from '../../ListingCardNew/ListingCardNew'
import { Grid, GridItem, Box } from '@homebotapp/hb-react-component-catalog'
import { ClientEventName, ClientEventSource, ListingCompact } from '../../../../api/gqlaxy/gql/generated/graphql'
import { HOME_SEARCH_LISTING_DETAILS } from '../../../../constants/tracking/trackingEventLocations/homeSearchTrackingEventLocation'
import { Waypoint } from 'react-waypoint'
import { useTrackingContext } from '../../../../providers/tracking'
import { useTrackingDebounceSetters } from '../../../../hooks/tracking'
import { LISTINGS_DETAILED, SIMILAR_HOMES } from '../../../../constants/tracking/trackingEventConstants'
import { useCreateClientEventOnView } from '../../../../hooks/useCreateClientEventOnView'

export const MSG = defineMessages({
  head: {
    id: 'ListingDetails.SimilarHomes.head',
    defaultMessage: 'Similar homes'
  }
})

export interface SimilarHomesProps {
  similarListings: ListingCompact[]
  listingId?: string
}

export const SimilarHomes = ({ similarListings, listingId }: SimilarHomesProps) => {
  const intl = useIntl()
  const { trackingClient } = useTrackingContext()
  const [trackModuleViewed] = useTrackingDebounceSetters(
    () =>
      trackingClient?.moduleViewed({
        event_source: LISTINGS_DETAILED,
        module_name: SIMILAR_HOMES
      })
  )
  const createModuleViewedClientEvent = useCreateClientEventOnView({
    eventName: ClientEventName.ModuleViewed,
    eventSource: ClientEventSource.ListingDetailed,
    location: SIMILAR_HOMES,
    listingId: listingId,
    eventProperties: {
      module_name: SIMILAR_HOMES
    }
  })

  const trackAmplitudeAndCreateClientEvent = () => {
    trackModuleViewed()
    createModuleViewedClientEvent()
  }

  if (similarListings?.length === 0) return null

  return (
    <Section>
      <Section.Heading>{intl.formatMessage(MSG.head)}</Section.Heading>
      <Box>
        <Waypoint onEnter={trackAmplitudeAndCreateClientEvent} bottomOffset='25%' />
        <Grid templateColumns={['repeat(1, 1fr)', null, 'repeat(2, 1fr)', null, 'repeat(4, 1fr)']} gap={4}>
          {similarListings.slice(0, 4).map(listing => (
            <GridItem key={listing.id}>
              <ListingCardNew
                listing={listing}
                tracking={{
                  guid: '4t4Aoae6B6nvKy8RpQLeWL',
                  ui_context: HOME_SEARCH_LISTING_DETAILS,
                  descriptor: 'Similar Listing Clicked'
                }}
              />
            </GridItem>
          ))}
        </Grid>
      </Box>
    </Section>
  )
}
